var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.hasRenderedProfile)?_c('LoaderIndicator',{staticClass:"loader",attrs:{"with-container":""}}):_vm._e(),(!_vm.loadingCustomer)?_c('div',[_c('UserProfile',{attrs:{"data-testid":"user-profile","user":_vm.customer},on:{"loaded":_vm.profileRendered}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }